import { format } from 'date-fns';
import { Style, Text } from 'es-map-widget';
import { useCallback, useEffect } from 'react';
import { api } from '../../hooks/useApi';
import useNotify from '../../hooks/useNotify';
import { styles, textStyle } from '../mapwrapper/MapWrapperStyles';
import { useAppControl } from '../../providers/AppContext';

const RadarMeparDataprovider = ({ extent, layerData, setSource }) => {
    const { notifyError } = useNotify();
    const { year } = useAppControl();

    const getMepars = useCallback(
        async (controller, params) =>
            api.layers
                .listMeparsForRadarDay(params, { signal: controller.signal })
                .then((res) => res.data),
        [api]
    );

    const addStyleToMepars = (meparsWithoutStyle) =>
        meparsWithoutStyle.map((e) => ({
            ...e,
            style: new Style({
                ...styles.mepar,
                text: new Text({
                    ...textStyle,
                    text: e.meparCode,
                }),
            }),
        }));

    useEffect(() => {
        if (!layerData.isLayerVisible) {
            setSource(null);
            return;
        }

        const controller = new AbortController();
        getMepars(controller, { extent, radarDate: format(layerData.date, 'yyyy-MM-dd'), year })
            .then((newMepars) => {
                setSource(addStyleToMepars(newMepars));
            })
            .catch((err) => {
                if (err.code !== 'ERR_CANCELED') {
                    notifyError(err);
                }
            });

        // eslint-disable-next-line consistent-return
        return () => {
            controller.abort();
        };
    }, [layerData, getMepars, extent, addStyleToMepars, setSource]);

    return null;
};

export default RadarMeparDataprovider;
